export default __webpack_public_path__ + "static/iphone-read-translate-d8ca385b6d71abf9a62701da6216a710.png";